export default __webpack_public_path__ + "static/media/setting.f1a3a921.svg";